import React from 'react';

export default function MissionKey() {
    return (
        <div className="d-inline-flex">
            <p>
                <span className="px-3 mr-2 bg-success" /> = Active
            </p>
            <p className="px-3" > </p>
            <p>
                <span className="px-3 mr-2 bg-danger" /> = No active
            </p>
        </div>
    );
};
